import { Button, Grid, Paper, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import useCloudControllers from 'v2/hooks/useCloudControllers/useCloudControllers';

interface Props {
  deviceId: string;
}

const DeviceDebug: React.FC<Props> = ({ deviceId }) => {
  const { translation } = useTranslation();
  const { showSnackbar } = useSnackbarContext();
  const { openDoor, openingDoor, identifyReader, identifyingReader } = useCloudControllers({
    translation,
    handleFetchError: (msg) => showSnackbar(msg, { severity: 'error' })
  });

  const handleOpenDoor = async (doorId: string) => {
    const success = await openDoor(doorId);
    if (success) {
      showSnackbar(translation.open_door_sent, { severity: 'success' });
    }
  };

  const handleIdentifyReader = async (doorId: string) => {
    const success = await identifyReader(doorId);
    if (success) {
      showSnackbar(translation.identify_reader_sent, { severity: 'success' });
    }
  };

  return (
    <Paper
      elevation={3}
      sx={{
        padding: '24px',
        borderRadius: 1,
        width: '100%'
      }}
    >
      <Grid container direction="column" spacing={2}>
        <Grid container direction="row" wrap="nowrap" justifyContent="space-between">
          <Typography variant="h5">Debug</Typography>
        </Grid>
        <Grid container spacing={1}>
          <Button
            id={`open-door-button`}
            onClick={() => handleOpenDoor(deviceId)}
            variant="outlined"
            sx={{ alignSelf: 'center' }}
            loading={openingDoor}
          >
            {translation.open_door}
          </Button>
          <Button
            id={`identify-reader-button`}
            onClick={() => handleIdentifyReader(deviceId)}
            variant="outlined"
            sx={{ alignSelf: 'center' }}
            loading={identifyingReader}
          >
            {translation.identify_reader}
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default DeviceDebug;
